import styles from './AboutIndustry.module.scss';

export const AboutIndustry = () => {
  const text = `For basketball, The Rivals Industry Ranking equally weights the primary recruiting media services. The algorithm is weighted as follows: 247Sports (33%), Rivals.com (33%), and ESPN (33%).`;

  return (
    <div className={styles.block}>
      <h2>Industry Comparison Data</h2>
      <div className={styles.container}>
        <p>
          The Rivals Industry Ranking is a proprietary algorithm that compiles
          ratings and rankings from all three primary recruiting media services.
          The Rivals Industry Ranking is the industry&apos;s most advanced,
          complete and unbiased rating and ranking measurement.
        </p>
        <p>{text}</p>
      </div>
    </div>
  );
};
